import pako from 'pako'
import { Buffer } from 'buffer'

export default {
	compress(input : Buffer)
	{
		console.log(`compressing input of length ${input.length}`)
		return pako.gzip(input);
	},
	decompress(input : Buffer)
	{
		console.log(`decompressing input of length ${input.length}`)
		return pako.ungzip(input);
	}
}